import { render, staticRenderFns } from "./LocationStatistic.vue?vue&type=template&id=dd4257e2&scoped=true&"
import script from "./LocationStatistic.vue?vue&type=script&lang=js&"
export * from "./LocationStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4257e2",
  null
  
)

export default component.exports